import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { defineCustomElements } from '@ionic/pwa-elements/loader';

import { environment, initSentry, LoggerService } from '@innership-app/core';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

const logger = new LoggerService();

defineCustomElements(window);

if (environment.production) {
  enableProdMode();
}

initSentry('web');

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((err) => logger.error('Failed to bootstrap web app', err));
